export default __webpack_public_path__ + "static/media/selected.5b2fb266.svg";